// interactive
import './interactive/ImportScript';
//import './interactive/Navbar';
//import './interactive/Header';
import './interactive/SearchBox';
import './interactive/Accordion';
import './interactive/Tab';
import './interactive/Modal';
import './interactive/Tree';
import './interactive/Dropdown';
//import './interactive/Validate';
import './interactive/LoadingScreen';
//import './interactive/LanguageSelect';
import './interactive/Carousel';
//import './interactive/Parallax';
import './interactive/Filter';
import './interactive/ShareButton';


import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

